import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

function Hide(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(G, {
    clipPath: "url(#prefix__clip0_3837_2553)"
  }, React.createElement(Path, {
    d: "M4.65 8.39l1.34 1.49-.38.39a8.82 8.82 0 00-1.62 2.45v.15a1 1 0 01-.51.56 1 1 0 01-.75 0 1 1 0 01-.57-.49 1 1 0 01-.07-.75 3.05 3.05 0 01.13-.32c.106-.26.226-.513.36-.76.432-.826.97-1.593 1.6-2.28.15-.154.306-.301.47-.44zM21.31 13.59a1 1 0 01-.77-.06 1 1 0 01-.5-.57 8.81 8.81 0 00-1.65-2.6 8.31 8.31 0 00-6.4-2.77 10 10 0 00-2.42.29L8.1 6.25a11.14 11.14 0 013.89-.66 10.28 10.28 0 017.86 3.32 11 11 0 012 3l.09.22c.02.072.038.146.05.22v.2c0 .02.17.71-.68 1.04zM8.19 12.34l4.63 5.16c-.273.06-.55.09-.83.09a4.002 4.002 0 01-3.8-5.25z"
  }), React.createElement(Path, {
    d: "M15.99 13.59a4.205 4.205 0 01-.19 1.23l-4.62-5.14c.266-.06.537-.09.81-.09a4 4 0 014 4zM17.86 20.11a.999.999 0 01-1.42-.08l-2.6-2.9-5.18-5.77-1.91-2.13-1.34-1.49-2.75-3.07a1 1 0 01.406-1.613 1 1 0 011.084.273l3 3.33 1.39 1.56 1.62 1.82 5.17 5.76 2.6 2.9a1 1 0 01-.07 1.41z"
  })), React.createElement(Defs, null, React.createElement(ClipPath, {
    id: "prefix__clip0_3837_2553"
  }, React.createElement(Path, {
    d: "M0 0h20v17.36H0z",
    transform: "translate(2 3)"
  }))));
}

export default Hide;